var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#DB4957"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9H17v1h-1v6.5a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5V10H7V9h2.5V7.5A.5.5 0 0110 7h4a.5.5 0 01.5.5V9zm.5 1H9v6h6v-6zm-4.5 1.5h1v3h-1v-3zm2 0h1v3h-1v-3zm-2-3.5v1h3V8h-3z",
    fill: "#fff"
  })));
}

export default SvgLedDelete;